module.exports = __webpack_public_path__ + "img/IMG_20180627_151310.8fcbf33d.jpg";